const InterviewProjectInformation = [{label: 'All projects', value: ''}];
export default InterviewProjectInformation;
